import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import AddLocationModal from './AddLocationModal';
import { jobCreationSteps } from '../../../../../constants/jobs';
import JobSchedule from './JobSchedule';
import CostPayRates from './CostPayRates';
import Loader from '../../../../common/ui/Loader';
import NavButtons from '../NavButtons';
import UsersService from '../../../../../services/UsersService';
import NoRateFound from '../../common/NoRateFound';

export default class LocationScheduleStep extends Component {
  static propTypes = {
    selectedLocation: PropTypes.object,
    companyLocations: PropTypes.array.isRequired,
    locationsList: PropTypes.array.isRequired,
    selectedEventData: PropTypes.object,
    costPayRateList: PropTypes.array.isRequired,
    costPayRateIsLoading: PropTypes.bool.isRequired,
    jobsList: PropTypes.array.isRequired,
    isLta: PropTypes.bool.isRequired,
    selectedWorkersInfoIsShown: PropTypes.bool.isRequired,
    companyDetails: PropTypes.shape({
      ltaWorkers: PropTypes.array.isRequired,
      favAndBlocks: PropTypes.array.isRequired
    }),
    jobCostRate: PropTypes.oneOfType([
      PropTypes.string, // in case when field is empty it will be equal to empty string
      PropTypes.number
    ]),
    workerPayRate: PropTypes.oneOfType([
      PropTypes.string, // in case when field is empty it will be equal to empty string
      PropTypes.number
    ]),
    setJobsList: PropTypes.func.isRequired,
    handleSelectLocation: PropTypes.func.isRequired,
    addLocationToJob: PropTypes.func.isRequired,
    isSecondStepFilled: PropTypes.func.isRequired,
    goToStep: PropTypes.func.isRequired,
    setCalendarRef: PropTypes.func.isRequired,
    handleChangeCostPayRate: PropTypes.func.isRequired
  };

  state = {
    locationModalIsOpen: false
  };

  openAnotherLocationModal = () => {
    this.setState({ locationModalIsOpen: true });
  };

  closeAddLocationModal = () => {
    this.setState({ locationModalIsOpen: false });
  };

  addLocationToJob = locationData => {
    return this.props.addLocationToJob(locationData).then(() => {
      this.closeAddLocationModal();
    });
  };

  render () {
    const { companyLocations, companyDetails, locationsList, selectedLocation, handleSelectLocation, isSecondStepFilled, goToStep,
      costPayRateList, costPayRateIsLoading, jobsList, setJobsList, jobCostRate, workerPayRate, handleChangeCostPayRate,
      setCalendarRef, selectedEventData, isLta, selectedWorkersInfoIsShown } = this.props;
    const { locationModalIsOpen } = this.state;
    const options = companyLocations.map(location => ({
      label: `${location.location_name}, ${location.address}`,
      value: location.id,
      data: location
    }));
    const locationIsSelected = selectedLocation && !!selectedLocation.value;
    const locationIsOutside = locationIsSelected && costPayRateList.length === 0;
    const locationIsValid = locationIsSelected && !locationIsOutside;
    const isAdmin = UsersService.isAdmin();
    return (
      <Fragment>
        <div className='d-flex justify-content-between flex-wrap'>
          <section className={`job-posting-section ${isAdmin ? 'half-width' : 'w-100'}`}>
            <header><h4>Job Location</h4></header>
            <Select
              onChange={handleSelectLocation}
              options={options}
              placeholder='Choose'
              value={selectedLocation}
            />
            <p className='mt-2'>
              Choose from list or
              <button className='additional-link non-button' onClick={this.openAnotherLocationModal}>
                Add Another Location
              </button>
            </p>
            <AddLocationModal
              isOpen={locationModalIsOpen}
              closeModal={this.closeAddLocationModal}
              locationsList={locationsList}
              addLocationToJob={this.addLocationToJob}
            />
          </section>
          { locationIsValid && isAdmin && (
            <CostPayRates
              jobCostRate={jobCostRate}
              workerPayRate={workerPayRate}
              handleChangeCostPayRate={handleChangeCostPayRate}
            />
          )}
        </div>
        { locationIsOutside && (
          <Fragment>
            { costPayRateIsLoading ? (
              <div>
                <div className='loader-wrapper'><Loader /></div>
              </div>
            ) : (
              <NoRateFound use_custom_rate={companyDetails.use_custom_rate} />
            )}
          </Fragment>
        )}
        { locationIsValid && (
          <JobSchedule
            jobsList={jobsList}
            setJobsList={setJobsList}
            jobCostRate={jobCostRate}
            setCalendarRef={setCalendarRef}
            companyDetails={companyDetails}
            isLta={isLta}
            selectedEventData={selectedEventData}
            selectedWorkersInfoIsShown={selectedWorkersInfoIsShown}
          />
        )}
        <NavButtons
          showNextButton={isSecondStepFilled() && !locationIsOutside}
          goToStep={goToStep}
          backStepId={jobCreationSteps.first.id}
          nextStepId={jobCreationSteps.third.id}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/LocationScheduleStep/index.js